import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { LoggingService } from "../services/logging.service";
import { UserService } from "../services/user.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(private userService: UserService, private router: Router) {
    LoggingService.log("AuthGuard ctor");
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    LoggingService.log("AuthGuard canActivate");
    return this.canAccess(state.url);
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    LoggingService.log("AuthGuard canActivateChild");
    return this.canAccess(state.url);
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    LoggingService.log("AuthGuard canLoad");
    return this.canAccess(segments && segments.length > 0 ? `/${segments.map(i => i.path).join("/")}` : null);
  }

  canAccess(redirectUrl: string): Observable<boolean> {
    return this.userService.authorized$().pipe(
      tap(authorized => {
        LoggingService.log(`AuthGuard - authorized? ${authorized} - redirectUrl? ${redirectUrl}`);
        if (!authorized) {
          if (!redirectUrl) {
            redirectUrl = "/";
          }

          this.router.navigate(["/auth"], { queryParams: { r: redirectUrl } });
        }
      }),
    );
  }
}
